import { render, staticRenderFns } from "./rgTemplateSettings.vue?vue&type=template&id=4b8ddea2&"
import script from "./rgTemplateSettings.vue?vue&type=script&lang=ts&"
export * from "./rgTemplateSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports